<div
  class="hover:bg-gray-50 cursor-pointer relative min-h-[auto]"
  [class.bg-gray-50]="currentConversationUuid === conversation.uuid"
  (click)="onConversationClick()"
  data-testid="copilot-conversation-item">
  <div class="flex justify-between items-center py-1">
    <div class="flex items-center gap-2 flex-1 min-w-0 px-1">
      <ui-loading-spinner *ngIf="showLoadingSpinner" [size]="16" class="flex-shrink-0 w-4 h-4"></ui-loading-spinner>
      <p class="text-gray-900 text-sm md:text-sm truncate min-w-0 m-0">{{ conversation.description }}</p>
    </div>

    <ui-more-menu-trigger [matMenuTriggerFor]="menu" [suppressClick]="true"></ui-more-menu-trigger>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onDeleteClick($event)">
        <div class="flex items-center gap-2">
          <ui-button icon="griddy-trash-alt" variant="quaternary" size="sm" class="!p-0 !min-w-0"></ui-button>
          <span>Delete</span>
        </div>
      </button>
    </mat-menu>
  </div>
</div>
